module.exports = __webpack_public_path__ + "img/check.3bd50c1a.svg";